// extracted by mini-css-extract-plugin
export default {"sharing__numbers":"aI3fW","sharing__numbers__size":"nJEIL","sharing__numbers__text":"Go10W","sharing__numbers--wide":"o8I2I","sharing__numbers--max":"ztMbn"};